var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "go-empty" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("p", { staticClass: "go-info-lead" }, [
      _vm._v(_vm._s(_vm.$t("search.empty-2.text-1"))),
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "go-info-text" }, [
      _vm._v("\n    " + _vm._s(_vm.$t("search.empty-2.text-2"))),
      _c("br"),
      _vm._v("\n    " + _vm._s(_vm.$t("search.empty-2.text-3")) + "\n  "),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "go-icon-wrap" }, [
      _c("i", { staticClass: "go-icon-72 go-icon-search" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }